'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _googleMapReact = require('google-map-react');

var _googleMapReact2 = _interopRequireDefault(_googleMapReact);

var _reactBootstrap = require('react-bootstrap');

var _MapMarker = require('./MapMarker');

var _MapMarker2 = _interopRequireDefault(_MapMarker);

var _reactRedux = require('react-redux');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleMapConfig = {
  key: _config2.default.googleMapKey
};
var LocationDetail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    shop: state.shops.shop
  };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(LocationDetail, _Component);

  function LocationDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LocationDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LocationDetail.__proto__ || (0, _getPrototypeOf2.default)(LocationDetail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      zoom: 14,
      style: _this.props.style || require('./Detail.scss')
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LocationDetail, [{
    key: 'render',
    value: function render() {
      var styles = this.state.style;
      var shop = this.props.shop;

      return _react2.default.createElement(
        'div',
        { className: styles.contentTab + ' ' + styles.location, id: 'location' },
        _react2.default.createElement(
          'div',
          { className: styles.headerTab },
          _react2.default.createElement(
            'h2',
            { className: styles.leftHeaderTab },
            _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'map-marker' }),
            'V\u1ECB tr\xED',
            ' ',
            _react2.default.createElement(
              'span',
              { className: styles.span },
              shop && shop.addressDisplay ? shop.addressDisplay : shop.address
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bodyTab },
          _react2.default.createElement(
            'div',
            { className: styles.map },
            shop && shop.location && _react2.default.createElement(
              _googleMapReact2.default,
              {
                center: shop.location,
                resetBoundsOnResize: true,
                zoom: this.state.zoom,
                bootstrapURLKeys: GoogleMapConfig
              },
              _react2.default.createElement(_MapMarker2.default, {
                lat: shop.location && shop.location.lat,
                lng: shop.location && shop.location.lng
              })
            )
          )
        )
      );
    }
  }]);
  return LocationDetail;
}(_react.Component), _class2.propTypes = {
  shop: _react.PropTypes.object,
  style: _react.PropTypes.any
}, _temp2)) || _class);
exports.default = LocationDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Detail/LocationDetail.js
// module id = 724
// module chunks = 0